// // context/LanguageContext.js
// import { createContext, useContext, useEffect, useState } from "react";
// import { useRouter } from "next/router";

// const LanguageContext = createContext();

// export const LanguageProvider = ({ children }) => {
//   const router = useRouter();

//   // Load saved locale or fallback to router.locale or 'en'
//   const [locale, setLocale] = useState(
//     typeof window !== "undefined"
//       ? localStorage.getItem("locale") || router.locale || "en"
//       : "en"
//   );

//   useEffect(() => {
//     // Update HTML attributes
//     document.documentElement.lang = locale;
//     document.documentElement.dir = locale === "ar" ? "rtl" : "ltr";

//     // Save to localStorage
//     localStorage.setItem("locale", locale);
//   }, [locale]);

//   const changeLanguage = (newLocale) => {
//     const path = router.asPath;
//     router.push(path, path, { locale: newLocale });
//     setLocale(newLocale);
//   };

//   return (
//     <LanguageContext.Provider value={{ locale, changeLanguage }}>
//       {children}
//     </LanguageContext.Provider>
//   );
// };

// export const useLanguage = () => useContext(LanguageContext);

// context/LanguageContext.js
import { createContext, useContext, useEffect, useState } from "react";
import { useRouter } from "next/router";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const router = useRouter();
  const [locale, setLocale] = useState(router.locale || "en");

  useEffect(() => {
    // Sync state with route locale
    const handleRouteChange = () => {
      const newLocale = router.locale || "en";
      setLocale(newLocale);

      // Set direction and lang
      document.documentElement.lang = newLocale;
      document.documentElement.dir = newLocale === "ar" ? "rtl" : "ltr";

      // Persist
      localStorage.setItem("locale", newLocale);
    };

    handleRouteChange(); // run on mount

    router.events.on("routeChangeComplete", handleRouteChange);
    return () => router.events.off("routeChangeComplete", handleRouteChange);
  }, [router]);

  const changeLanguage = (newLocale) => {
    const path = router.asPath;
    router.push(path, path, { locale: newLocale });
  };

  return (
    <LanguageContext.Provider value={{ locale, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
